import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ["url", "size"]

  generateCode(event){
    event.preventDefault()
    let url = this.urlTarget.value
    let size = this.sizeTarget.value
    let src = `http://chart.apis.google.com/chart?chs=${size}x${size}&cht=qr&chl=${url}&chld=L|2&choe=UTF-8`
    document.getElementById("qrcode-img").src = src
  }
}
